import React from 'react';
import ButtonGroup, { ButtonOption } from '@amzn/meridian/button-group';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import { FormikProps } from 'formik';
import { ButtonGroupProps } from '@amzn/meridian/button-group/button-group';
import { RowProps } from '@amzn/meridian/row/row';
import Column from '@amzn/meridian/column';

interface FormikRangedButtonGroupProps {
  formik: FormikProps<any>;
  fieldName: string;
  min: number;
  max: number;
  minLabel?: string | React.ReactNode;
  maxLabel?: string | React.ReactNode;
  disabled?: boolean;
  buttonGroupProps?: Omit<ButtonGroupProps, 'children'>;
  buttonGroupSpacingInset?: RowProps['spacingInset'];
}

const FormikRangedButtonGroup: React.FC<FormikRangedButtonGroupProps> = ({
  formik,
  fieldName,
  min,
  max,
  minLabel,
  maxLabel,
  disabled = false,
  buttonGroupProps,
  buttonGroupSpacingInset = 'none 500',
}) => {
  const currentValue = formik.values[fieldName];
  const buttons: React.ReactElement[] = [];

  for (let i = min; i <= max; i++) {
    buttons.push(
      <ButtonOption key={i} value={i} disabled={disabled}>
        {i}
      </ButtonOption>
    );
  }

  return (
    <Column spacing='200' spacingInset='none' width='min-content'>
      <Row spacing='none' spacingInset={buttonGroupSpacingInset}>
        <ButtonGroup
          type='outline'
          value={currentValue}
          onChange={selection => {
            formik.setFieldValue(fieldName, selection);
          }}
          {...buttonGroupProps}
        >
          {buttons}
        </ButtonGroup>
      </Row>
      {(minLabel || maxLabel) && (
        <Row
          alignmentHorizontal='justify'
          alignmentVertical='center'
          spacing='none'
          spacingInset='200 none none none'
        >
          <Text type='b200'>{minLabel}</Text>
          <Text type='b200' alignment='right'>
            {maxLabel}
          </Text>
        </Row>
      )}
    </Column>
  );
};

export default FormikRangedButtonGroup;
